import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaRocket,
  FaEye,
  FaUsers,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ProductLaunchVideoProductionInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Product Launch Video Production in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Unveil Your Product</Subheading>}
        heading={
          <Heading>
            Product Launch <span tw="text-primary-500">Video Production</span>{" "}
            in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer professional product launch video
            production services in **Dubai**, creating cinematic, high-impact
            videos that showcase your product and captivate audiences. Drive
            brand awareness and conversions with compelling storytelling
            tailored for launches.
          </Description>
        }
        // For the Hero Section
        // For the Hero Section
        imageSrcs={[
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1601524909162-ae8725290836?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1579389083078-4e7018379f7e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch Your Product Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Product Launch Video Production in Dubai"
        description="We create videos that make your product shine."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Storytelling",
            description:
              "Compelling narratives to highlight your product’s value.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Proven success with Dubai’s top brands.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Timely production for launch deadlines.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Audience Engagement",
            description: "Videos designed to attract and convert.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Tailored Content",
            description: "Customized for your product and audience.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Optimized for social media, websites, and events.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Product Launch Video Production Process"
        description={
          <Description>
            We craft impactful product launch videos with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your product and launch goals.</li>
              <li>
                Creative: Develop scripts and storyboards for maximum impact.
              </li>
              <li>
                Filming: Use 4K cameras and professional crews for stunning
                visuals.
              </li>
              <li>
                Editing: Enhance with motion graphics, animations, and sound
                design.
              </li>
              <li>Delivery: Provide polished videos ready for your launch.</li>
              <li>Support: Offer revisions and performance insights.</li>
            </ul>
          </Description>
        }
        // For the Our Process Section
        imageSrcs={[
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1504270997636-07ddfbd48945?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1585974738771-84483dd9f89f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Product Launch Video Wins in Dubai"
        description="Our videos have driven successful launches."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Tech Product Launch",
            description: "Boosted pre-orders with a viral video.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Awareness",
            description: "Increased reach for a luxury product.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "97% approval from launch video clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Launch?</Subheading>}
        heading="Product Launch Video Production in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for professional product launch video
            production services in Dubai. Get cinematic, high-impact videos that
            drive excitement and results—contact us today!
          </Description>
        }
        // For the Call-to-Action Section
        imageSrcs={[
          "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
